
import { Vue, Component } from "vue-property-decorator";
import * as AuthStore from "./store/modules/auth";
import Snack from "./components/Snack.vue";
import Layout from "./components/Layout.vue";

@Component({
  components: {
    Snack,
    Layout
  }
})
export default class App extends Vue {
  get isAuthenticated() {
    return AuthStore.getters.isAuthenticated;
  }
}
